import { Instance, types } from "mobx-state-tree";

import { globalModule } from "../service-provider/GlobalModule";
import { registerGlobalService } from "../service-provider/ServiceRegistry";
import { TranslationContext } from "../translation/TranslationService";

const notificationDisplayDuration = 6000;

export const SnackbarNotificationModel = types.model({
  status: types.enumeration("Status", ["success", "error"]),
  messageKey: types.string,
  messageContext: types.maybe(types.frozen<TranslationContext>()),
  identifier: types.string,
});

export const SnackbarNotificationsServiceModel = types
  .model({
    snackbarNotifications: types.optional(types.array(SnackbarNotificationModel), []),
  })
  .actions((self) => ({
    removeFirstSnackbarNotification() {
      self.snackbarNotifications.shift();
    },
  }))
  .actions((self) => {
    const createSnackbarNotification = (
      messageKey: string,
      messageContext: TranslationContext | undefined,
      status: "success" | "error"
    ) => {
      return SnackbarNotificationModel.create({
        status: status,
        messageKey: messageKey,
        messageContext: messageContext,
        identifier: Date.now().toString(),
      });
    };

    const removeSnackbarNotificationAfterDisplay = () => {
      setTimeout(self.removeFirstSnackbarNotification, notificationDisplayDuration);
    };

    return {
      showSuccess(messageKey: string, messageContext?: TranslationContext) {
        const snackbarNotification = createSnackbarNotification(
          messageKey,
          messageContext,
          "success"
        );
        self.snackbarNotifications.push(snackbarNotification);
        removeSnackbarNotificationAfterDisplay();
      },

      showError(messageKey: string, messageContext?: TranslationContext) {
        const snackbarNotification = createSnackbarNotification(
          messageKey,
          messageContext,
          "error"
        );
        self.snackbarNotifications.push(snackbarNotification);
        removeSnackbarNotificationAfterDisplay();
      },
    };
  });

export type SnackbarNotificationsService = Instance<typeof SnackbarNotificationsServiceModel>;
export type SnackbarNotification = Instance<typeof SnackbarNotificationModel>;
export const snackbarNotificationsService = SnackbarNotificationsServiceModel.create();
globalModule.snackbarNotificationsService = snackbarNotificationsService;
export default registerGlobalService(snackbarNotificationsService as SnackbarNotificationsService);
